/**
 * Checks if the current device is a mobile or touch-enabled device.
 */
export default function isMobile(): boolean {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}
